// Application constants

export const APP_CONFIG = {
  name: 'YKS Takip',
  version: '1.0.0',
  description: 'Yükseköğretim Kurumları Sınavı Hazırlık ve Takip Platformu',
  author: 'YKS Takip Team',
  website: 'https://lgstakip.com',
  support: 'support@lgstakip.com',
  privacy: 'https://lgstakip.com/privacy',
  terms: 'https://lgstakip.com/terms'
}

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  DASHBOARD: '/dashboard',
  STUDY: {
    BASE: '/study',
    PLANS: '/study/plans',
    SESSIONS: '/study/sessions',
    GOALS: '/study/goals'
  },
  EXAMS: {
    BASE: '/exams',
    TRIALS: '/exams/trials',
    RESULTS: '/exams/results'
  },
  QUESTIONS: {
    BANK: '/questions/bank'
  },
  ANALYTICS: {
    BASE: '/analytics',
    DASHBOARD: '/analytics/dashboard',
    PERFORMANCE: '/analytics/performance',
    PROGRESS: '/analytics/progress',
    TIME: '/analytics/time',
    SUBJECTS: '/analytics/subjects'
  },


  POMODORO: '/pomodoro',
  GOALS: '/goals',
  CALENDAR: '/calendar',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  LEADERBOARD: '/leaderboard',
  SHOP: '/shop',
  ACHIEVEMENTS: '/achievements',
  STUDY_GROUPS: '/study-groups',
  CHALLENGES: '/challenges',
  HELP: '/help',
  ABOUT: '/about',
  NOTIFICATIONS: '/notifications',
  NOTES: '/tools/notes',
  SUMMARIES: '/tools/summaries',
  GAMIFICATION: {
    BASE: '/gamification',
    BADGES: '/gamification/badges',
    ACHIEVEMENTS: '/gamification/achievements',
    LEADERBOARD: '/gamification/leaderboard',
    SHOP: '/gamification/shop',
    QUESTS: '/gamification/quests'
  },
  SOCIAL: {
    BASE: '/social',
    GROUPS: '/social/groups',
    COMPETITIONS: '/social/competitions',
    FORUM: '/social/forum'
  },
  ADMIN: {
    BASE: '/admin',
    ACTIVATION_CODES: '/admin/activation-codes'
  }
} as const

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    LOGOUT: '/api/auth/logout',
    REFRESH: '/api/auth/refresh',
    FORGOT_PASSWORD: '/api/auth/forgot-password',
    RESET_PASSWORD: '/api/auth/reset-password',
    VERIFY_EMAIL: '/api/auth/verify-email',
    CHANGE_PASSWORD: '/api/auth/change-password'
  },
  USER: {
    PROFILE: '/api/user/profile',
    UPDATE: '/api/user/update',
    DELETE: '/api/user/delete',
    AVATAR: '/api/user/avatar',
    PREFERENCES: '/api/user/preferences',
    SETTINGS: '/api/user/settings'
  },
  STUDY: {
    SESSIONS: '/api/study/sessions',
    PLANS: '/api/study/plans',
    STATS: '/api/study/stats',
    STATISTICS: '/api/study/stats',
    SUBJECTS: '/api/study/subjects',
    TOPICS: '/api/study/topics'
  },
  EXAMS: {
    LIST: '/api/exams',
    QUESTIONS: '/api/exams/questions',
    RESULTS: '/api/exams/results',
    SUBMIT: '/api/exams/submit',
    ANALYTICS: '/api/exams/analytics',
    CREATE: '/api/exams/create',
    STATISTICS: '/api/exams/statistics'
  },
  MINDMAPS: {
    LIST: '/api/mindmaps',
    CREATE: '/api/mindmaps/create',
    UPDATE: '/api/mindmaps/update',
    DELETE: '/api/mindmaps/delete',
    SHARE: '/api/mindmaps/share'
  },

  SUBJECTS: {
    LIST: '/api/subjects'
  },
  QUESTIONS: {
    LIST: '/api/questions'
  },
  POMODORO: {
    SESSIONS: '/api/pomodoro/sessions',
    STATISTICS: '/api/pomodoro/statistics'
  },
  GAMIFICATION: {
    PROFILE: '/api/gamification/profile',
    BADGES: '/api/gamification/badges',
    ACHIEVEMENTS: '/api/gamification/achievements',
    LEADERBOARD: '/api/gamification/leaderboard',
    SHOP: '/api/gamification/shop',
    QUESTS: '/api/gamification/quests'
  },
  SOCIAL: {
    FRIENDS: '/api/social/friends',
    GROUPS: '/api/social/groups',
    CHALLENGES: '/api/social/challenges',
    MESSAGES: '/api/social/messages'
  },
  ANALYTICS: {
    DASHBOARD: '/api/analytics/dashboard',
    PERFORMANCE: '/api/analytics/performance',
    PROGRESS: '/api/analytics/progress',
    REPORTS: '/api/analytics/reports',
    EXPORT: '/api/analytics/export'
  },
  NOTIFICATIONS: {
    LIST: '/api/notifications',
    MARK_READ: '/api/notifications/mark-read',
    SETTINGS: '/api/notifications/settings'
  },
  UPLOAD: {
    IMAGE: '/api/upload/image',
    FILE: '/api/upload/file',
    MULTIPLE: '/api/upload/multiple',
    AVATAR: '/api/upload/avatar'
  }
} as const

export const SUBJECTS = [
  {
    id: 'turkish',
    name: 'Türkçe',
    color: '#ef4444',
    icon: '📚',
    totalQuestions: 20
  },
  {
    id: 'math',
    name: 'Matematik',
    color: '#3b82f6',
    icon: '🔢',
    totalQuestions: 20
  },
  {
    id: 'science',
    name: 'Fen Bilimleri',
    color: '#10b981',
    icon: '🔬',
    totalQuestions: 20
  },
  {
    id: 'social',
    name: 'Sosyal Bilgiler',
    color: '#f59e0b',
    icon: '🌍',
    totalQuestions: 10
  },
  {
    id: 'english',
    name: 'İngilizce',
    color: '#8b5cf6',
    icon: '🇬🇧',
    totalQuestions: 10
  },
  {
    id: 'religion',
    name: 'Din Kültürü',
    color: '#06b6d4',
    icon: '☪️',
    totalQuestions: 10
  }
] as const

export const DIFFICULTY_LEVELS = {
  EASY: 'easy',
  MEDIUM: 'medium',
  HARD: 'hard'
} as const

export const QUESTION_TYPES = {
  MULTIPLE_CHOICE: 'multiple_choice',
  TRUE_FALSE: 'true_false',
  FILL_BLANK: 'fill_blank',
  ESSAY: 'essay',
  MATCHING: 'matching'
} as const

export const STUDY_TYPES = {
  STUDY: 'study',
  PRACTICE: 'practice',
  REVIEW: 'review',

  MINDMAP: 'mindmap'
} as const

export const EXAM_TYPES = {
  PRACTICE: 'practice',
  MOCK: 'mock',
  REAL: 'real',
  CUSTOM: 'custom'
} as const

export const NOTIFICATION_TYPES = {
  REMINDER: 'reminder',
  ACHIEVEMENT: 'achievement',
  EXAM: 'exam',
  SOCIAL: 'social',
  SYSTEM: 'system'
} as const

export const BADGE_CATEGORIES = {
  STUDY: 'study',
  EXAM: 'exam',
  STREAK: 'streak',
  ACHIEVEMENT: 'achievement',
  SOCIAL: 'social'
} as const

export const BADGE_RARITIES = {
  COMMON: 'common',
  RARE: 'rare',
  EPIC: 'epic',
  LEGENDARY: 'legendary'
} as const

export const QUEST_TYPES = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  SPECIAL: 'special'
} as const

export const QUEST_DIFFICULTIES = {
  EASY: 'easy',
  MEDIUM: 'medium',
  HARD: 'hard'
} as const

export const SHOP_ITEM_TYPES = {
  THEME: 'theme',
  AVATAR: 'avatar',
  STICKER: 'sticker',
  BACKGROUND: 'background',
  EFFECT: 'effect'
} as const

export const POMODORO_TYPES = {
  WORK: 'work',
  SHORT_BREAK: 'short_break',
  LONG_BREAK: 'long_break'
} as const





export const GOAL_TYPES = {
  STUDY_TIME: 'study_time',
  EXAM_SCORE: 'exam_score',
  STREAK: 'streak',
  SUBJECT_MASTERY: 'subject_mastery',
  CUSTOM: 'custom'
} as const

export const GOAL_CATEGORIES = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
  CUSTOM: 'custom'
} as const

export const PRIORITY_LEVELS = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high'
} as const

export const THEME_MODES = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'system'
} as const

export const LANGUAGES = {
  TR: 'tr',
  EN: 'en'
} as const

export const STORAGE_KEYS = {
  THEME: 'theme',
  COLOR_SCHEME: 'colorScheme',
  SIDEBAR_OPEN: 'sidebarOpen',
  SIDEBAR_COLLAPSED: 'sidebarCollapsed',
  FONT_SIZE: 'fontSize',
  LANGUAGE: 'language',
  USER_PREFERENCES: 'userPreferences',
  AUTH_TOKEN: 'authToken',
  REFRESH_TOKEN: 'refreshToken',
  USER_DATA: 'userData'
} as const

export const SUBSCRIPTION_TYPES = {
  FREE: 'free',
  PREMIUM: 'premium',
  PRO: 'pro'
} as const

export const PAYMENT_METHODS = {
  CARD: 'card',
  PAYPAL: 'paypal',
  BANK_TRANSFER: 'bank_transfer'
} as const

export const INVOICE_STATUSES = {
  PAID: 'paid',
  PENDING: 'pending',
  FAILED: 'failed',
  REFUNDED: 'refunded'
} as const

export const SUPPORT_CATEGORIES = {
  TECHNICAL: 'technical',
  BILLING: 'billing',
  FEATURE: 'feature',
  BUG: 'bug',
  OTHER: 'other'
} as const

export const TICKET_PRIORITIES = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  URGENT: 'urgent'
} as const

export const TICKET_STATUSES = {
  OPEN: 'open',
  IN_PROGRESS: 'in_progress',
  RESOLVED: 'resolved',
  CLOSED: 'closed'
} as const

export const FEATURE_STATUSES = {
  SUBMITTED: 'submitted',
  UNDER_REVIEW: 'under_review',
  PLANNED: 'planned',
  IN_DEVELOPMENT: 'in_development',
  COMPLETED: 'completed',
  REJECTED: 'rejected'
} as const

export const BUG_SEVERITIES = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  CRITICAL: 'critical'
} as const

export const RELEASE_TYPES = {
  MAJOR: 'major',
  MINOR: 'minor',
  PATCH: 'patch',
  HOTFIX: 'hotfix'
} as const

export const ANNOUNCEMENT_TYPES = {
  INFO: 'info',
  WARNING: 'warning',
  SUCCESS: 'success',
  ERROR: 'error'
} as const

export const FEEDBACK_TYPES = {
  RATING: 'rating',
  SUGGESTION: 'suggestion',
  COMPLAINT: 'complaint',
  COMPLIMENT: 'compliment'
} as const

export const DEVICE_TYPES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop'
} as const

export const CHART_TYPES = {
  LINE: 'line',
  BAR: 'bar',
  PIE: 'pie',
  DOUGHNUT: 'doughnut',
  AREA: 'area',
  SCATTER: 'scatter',
  RADAR: 'radar'
} as const

export const DATE_FORMATS = {
  SHORT: 'DD/MM/YYYY',
  LONG: 'DD MMMM YYYY',
  TIME: 'HH:mm',
  DATETIME: 'DD/MM/YYYY HH:mm',
  ISO: 'YYYY-MM-DDTHH:mm:ss.SSSZ'
} as const

export const TIME_PERIODS = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year'
} as const

export const SORT_ORDERS = {
  ASC: 'asc',
  DESC: 'desc'
} as const

export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 20,
  MAX_LIMIT: 100
} as const

export const FILE_TYPES = {
  IMAGE: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'],
  VIDEO: ['mp4', 'webm', 'ogg', 'avi', 'mov'],
  AUDIO: ['mp3', 'wav', 'ogg', 'aac', 'm4a'],
  DOCUMENT: ['pdf', 'doc', 'docx', 'txt', 'rtf'],
  SPREADSHEET: ['xls', 'xlsx', 'csv'],
  PRESENTATION: ['ppt', 'pptx'],
  ARCHIVE: ['zip', 'rar', '7z', 'tar', 'gz']
} as const

export const FILE_SIZE_LIMITS = {
  AVATAR: 5 * 1024 * 1024, // 5MB
  IMAGE: 10 * 1024 * 1024, // 10MB
  VIDEO: 100 * 1024 * 1024, // 100MB
  AUDIO: 50 * 1024 * 1024, // 50MB
  DOCUMENT: 25 * 1024 * 1024, // 25MB
  GENERAL: 50 * 1024 * 1024 // 50MB
} as const

export const VALIDATION_RULES = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
  PHONE: /^(\+90|0)?[0-9]{10}$/,
  USERNAME: /^[a-zA-Z0-9_]{3,20}$/,
  NAME: /^[a-zA-ZğüşıöçĞÜŞİÖÇ\s]{2,50}$/
} as const

export const ERROR_CODES = {
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  AUTHENTICATION_ERROR: 'AUTHENTICATION_ERROR',
  AUTHORIZATION_ERROR: 'AUTHORIZATION_ERROR',
  NOT_FOUND: 'NOT_FOUND',
  CONFLICT: 'CONFLICT',
  RATE_LIMIT: 'RATE_LIMIT',
  SERVER_ERROR: 'SERVER_ERROR',
  NETWORK_ERROR: 'NETWORK_ERROR',
  TIMEOUT_ERROR: 'TIMEOUT_ERROR'
} as const

export const SUCCESS_MESSAGES = {
  LOGIN: 'Başarıyla giriş yaptınız',
  REGISTER: 'Hesabınız başarıyla oluşturuldu',
  LOGOUT: 'Başarıyla çıkış yaptınız',
  PROFILE_UPDATED: 'Profiliniz güncellendi',
  PASSWORD_CHANGED: 'Şifreniz değiştirildi',
  EMAIL_VERIFIED: 'E-posta adresiniz doğrulandı',
  STUDY_SESSION_SAVED: 'Çalışma oturumu kaydedildi',
  EXAM_COMPLETED: 'Sınav tamamlandı',
  GOAL_ACHIEVED: 'Hedefinizi başardınız!',
  BADGE_EARNED: 'Yeni rozet kazandınız!',
  LEVEL_UP: 'Seviye atladınız!',
  FRIEND_ADDED: 'Arkadaş eklendi',
  GROUP_JOINED: 'Gruba katıldınız',
  CHALLENGE_COMPLETED: 'Meydan okuma tamamlandı',
  ITEM_PURCHASED: 'Öğe satın alındı',
  SETTINGS_SAVED: 'Ayarlar kaydedildi',
  FILE_UPLOADED: 'Dosya yüklendi',
  DATA_EXPORTED: 'Veriler dışa aktarıldı',
  BACKUP_CREATED: 'Yedek oluşturuldu',
  REMINDER_SET: 'Hatırlatıcı ayarlandı'
} as const

export const ERROR_MESSAGES = {
  INVALID_CREDENTIALS: 'Geçersiz kullanıcı adı veya şifre',
  EMAIL_ALREADY_EXISTS: 'Bu e-posta adresi zaten kullanımda',
  USERNAME_ALREADY_EXISTS: 'Bu kullanıcı adı zaten kullanımda',
  WEAK_PASSWORD: 'Şifre en az 8 karakter olmalı ve büyük harf, küçük harf, rakam ve özel karakter içermelidir',
  INVALID_EMAIL: 'Geçersiz e-posta adresi',
  REQUIRED_FIELD: 'Bu alan zorunludur',
  NETWORK_ERROR: 'Bağlantı hatası. Lütfen internet bağlantınızı kontrol edin',
  SERVER_ERROR: 'Sunucu hatası. Lütfen daha sonra tekrar deneyin',
  UNAUTHORIZED: 'Bu işlem için yetkiniz bulunmuyor',
  SESSION_EXPIRED: 'Oturumunuz sona erdi. Lütfen tekrar giriş yapın',
  FILE_TOO_LARGE: 'Dosya boyutu çok büyük',
  INVALID_FILE_TYPE: 'Geçersiz dosya türü',
  UPLOAD_FAILED: 'Dosya yüklenemedi',
  INSUFFICIENT_COINS: 'Yetersiz jeton',
  ALREADY_PURCHASED: 'Bu öğe zaten satın alınmış',
  GOAL_NOT_FOUND: 'Hedef bulunamadı',
  EXAM_NOT_FOUND: 'Sınav bulunamadı',
  STUDY_PLAN_NOT_FOUND: 'Çalışma planı bulunamadı',
  MINDMAP_NOT_FOUND: 'Zihin haritası bulunamadı',

  USER_NOT_FOUND: 'Kullanıcı bulunamadı',
  GROUP_NOT_FOUND: 'Grup bulunamadı',
  CHALLENGE_NOT_FOUND: 'Meydan okuma bulunamadı',
  ALREADY_FRIENDS: 'Zaten arkadaşsınız',
  FRIEND_REQUEST_PENDING: 'Arkadaşlık isteği beklemede',
  CANNOT_ADD_YOURSELF: 'Kendinizi arkadaş olarak ekleyemezsiniz',
  GROUP_FULL: 'Grup dolu',
  ALREADY_MEMBER: 'Zaten grup üyesisiniz',
  INVALID_INVITE_CODE: 'Geçersiz davet kodu',
  CHALLENGE_ENDED: 'Meydan okuma sona erdi',
  ALREADY_PARTICIPATING: 'Zaten katılıyorsunuz',
  RATE_LIMIT_EXCEEDED: 'Çok fazla istek. Lütfen bekleyin',
  MAINTENANCE_MODE: 'Sistem bakımda. Lütfen daha sonra tekrar deneyin'
} as const

export const LOADING_MESSAGES = {
  LOGGING_IN: 'Giriş yapılıyor...',
  REGISTERING: 'Hesap oluşturuluyor...',
  LOADING_DASHBOARD: 'Panel yükleniyor...',
  LOADING_EXAMS: 'Sınavlar yükleniyor...',
  LOADING_STUDY_PLANS: 'Çalışma planları yükleniyor...',
  LOADING_ANALYTICS: 'Analitikler yükleniyor...',


  LOADING_PROFILE: 'Profil yükleniyor...',
  SAVING_CHANGES: 'Değişiklikler kaydediliyor...',
  UPLOADING_FILE: 'Dosya yükleniyor...',
  PROCESSING_EXAM: 'Sınav işleniyor...',
  GENERATING_REPORT: 'Rapor oluşturuluyor...',
  EXPORTING_DATA: 'Veriler dışa aktarılıyor...',
  CREATING_BACKUP: 'Yedek oluşturuluyor...',
  SENDING_MESSAGE: 'Mesaj gönderiliyor...',
  JOINING_GROUP: 'Gruba katılınıyor...',
  STARTING_CHALLENGE: 'Meydan okuma başlatılıyor...'
} as const

export const PLACEHOLDER_TEXTS = {
  EMAIL: 'E-posta adresinizi girin',
  PASSWORD: 'Şifrenizi girin',
  CONFIRM_PASSWORD: 'Şifrenizi tekrar girin',
  NAME: 'Adınızı girin',
  SURNAME: 'Soyadınızı girin',
  USERNAME: 'Kullanıcı adınızı girin',
  PHONE: 'Telefon numaranızı girin',
  SEARCH: 'Ara...',
  SEARCH_USERS: 'Kullanıcı ara...',
  SEARCH_GROUPS: 'Grup ara...',
  SEARCH_EXAMS: 'Sınav ara...',
  SEARCH_QUESTIONS: 'Soru ara...',
  SEARCH_TOPICS: 'Konu ara...',
  MESSAGE: 'Mesajınızı yazın...',
  NOTES: 'Notlarınızı yazın...',
  DESCRIPTION: 'Açıklama yazın...',
  TITLE: 'Başlık girin...',
  GOAL_TITLE: 'Hedef başlığı...',
  PLAN_NAME: 'Plan adı...',
  GROUP_NAME: 'Grup adı...',
  CHALLENGE_NAME: 'Meydan okuma adı...',
  DECK_NAME: 'Deste adı...',

  QUESTION_TEXT: 'Soru metnini girin...',
  ANSWER_TEXT: 'Cevabı girin...',
  EXPLANATION: 'Açıklama girin...',
  TAGS: 'Etiketler (virgülle ayırın)...',
  URL: 'URL girin...',
  FEEDBACK: 'Geri bildiriminizi yazın...',
  REPORT_ISSUE: 'Sorunu açıklayın...',
  SUGGESTION: 'Önerinizi yazın...'
} as const

export const BUTTON_TEXTS = {
  LOGIN: 'Giriş Yap',
  REGISTER: 'Kayıt Ol',
  LOGOUT: 'Çıkış Yap',
  SAVE: 'Kaydet',
  CANCEL: 'İptal',
  DELETE: 'Sil',
  EDIT: 'Düzenle',
  CREATE: 'Oluştur',
  UPDATE: 'Güncelle',
  SUBMIT: 'Gönder',
  CONFIRM: 'Onayla',
  BACK: 'Geri',
  NEXT: 'İleri',
  PREVIOUS: 'Önceki',
  FINISH: 'Bitir',
  START: 'Başla',
  STOP: 'Durdur',
  PAUSE: 'Duraklat',
  RESUME: 'Devam Et',
  RESET: 'Sıfırla',
  REFRESH: 'Yenile',
  LOAD_MORE: 'Daha Fazla Yükle',
  SHOW_MORE: 'Daha Fazla Göster',
  SHOW_LESS: 'Daha Az Göster',
  EXPAND: 'Genişlet',
  COLLAPSE: 'Daralt',
  FILTER: 'Filtrele',
  SORT: 'Sırala',
  SEARCH: 'Ara',
  CLEAR: 'Temizle',
  SELECT_ALL: 'Tümünü Seç',
  DESELECT_ALL: 'Seçimi Kaldır',
  EXPORT: 'Dışa Aktar',
  IMPORT: 'İçe Aktar',
  DOWNLOAD: 'İndir',
  UPLOAD: 'Yükle',
  SHARE: 'Paylaş',
  COPY: 'Kopyala',
  PASTE: 'Yapıştır',
  CUT: 'Kes',
  UNDO: 'Geri Al',
  REDO: 'Yinele',
  PRINT: 'Yazdır',
  PREVIEW: 'Önizle',
  SETTINGS: 'Ayarlar',
  HELP: 'Yardım',
  ABOUT: 'Hakkında',
  CONTACT: 'İletişim',
  SUPPORT: 'Destek',
  FEEDBACK: 'Geri Bildirim',
  REPORT: 'Rapor Et',
  CLOSE: 'Kapat',
  MINIMIZE: 'Küçült',
  MAXIMIZE: 'Büyüt',
  FULLSCREEN: 'Tam Ekran',
  EXIT_FULLSCREEN: 'Tam Ekrandan Çık',
  PLAY: 'Oynat',
  PAUSE_MEDIA: 'Duraklat',
  MUTE: 'Sessiz',
  UNMUTE: 'Sesi Aç',
  VOLUME_UP: 'Sesi Artır',
  VOLUME_DOWN: 'Sesi Azalt',
  SKIP_FORWARD: 'İleri Sar',
  SKIP_BACKWARD: 'Geri Sar',
  REPEAT: 'Tekrarla',
  SHUFFLE: 'Karıştır',
  BOOKMARK: 'Yer İmi Ekle',
  FAVORITE: 'Favorilere Ekle',
  LIKE: 'Beğen',
  DISLIKE: 'Beğenme',
  FOLLOW: 'Takip Et',
  UNFOLLOW: 'Takibi Bırak',
  SUBSCRIBE: 'Abone Ol',
  UNSUBSCRIBE: 'Aboneliği İptal Et',
  INVITE: 'Davet Et',
  JOIN: 'Katıl',
  LEAVE: 'Ayrıl',
  ACCEPT: 'Kabul Et',
  DECLINE: 'Reddet',
  APPROVE: 'Onayla',
  REJECT: 'Reddet',
  BLOCK: 'Engelle',
  UNBLOCK: 'Engeli Kaldır',
  REPORT_USER: 'Kullanıcıyı Rapor Et',
  SEND_MESSAGE: 'Mesaj Gönder',
  CALL: 'Ara',
  VIDEO_CALL: 'Görüntülü Ara',
  SCHEDULE: 'Planla',
  RESCHEDULE: 'Yeniden Planla',
  POSTPONE: 'Ertele',
  ADVANCE: 'İlerlet',
  DUPLICATE: 'Çoğalt',
  ARCHIVE: 'Arşivle',
  RESTORE: 'Geri Yükle',
  BACKUP: 'Yedekle',
  SYNC: 'Senkronize Et',
  CONNECT: 'Bağlan',
  DISCONNECT: 'Bağlantıyı Kes',
  ENABLE: 'Etkinleştir',
  DISABLE: 'Devre Dışı Bırak',
  ACTIVATE: 'Aktifleştir',
  DEACTIVATE: 'Pasifleştir',
  INSTALL: 'Yükle',
  UNINSTALL: 'Kaldır',
  UPGRADE: 'Yükselt',
  DOWNGRADE: 'Düşür',
  PURCHASE: 'Satın Al',
  REFUND: 'İade Et',
  CHECKOUT: 'Ödeme Yap',
  ADD_TO_CART: 'Sepete Ekle',
  REMOVE_FROM_CART: 'Sepetten Çıkar',
  APPLY_COUPON: 'Kupon Uygula',
  REMOVE_COUPON: 'Kuponu Kaldır',
  CALCULATE: 'Hesapla',
  ESTIMATE: 'Tahmin Et',
  VALIDATE: 'Doğrula',
  VERIFY: 'Onayla',
  AUTHENTICATE: 'Kimlik Doğrula',
  AUTHORIZE: 'Yetkilendir',
  GRANT: 'İzin Ver',
  REVOKE: 'İptal Et',
  LOCK: 'Kilitle',
  UNLOCK: 'Kilidi Aç',
  ENCRYPT: 'Şifrele',
  DECRYPT: 'Şifre Çöz',
  COMPRESS: 'Sıkıştır',
  DECOMPRESS: 'Açıştır',
  OPTIMIZE: 'Optimize Et',
  ANALYZE: 'Analiz Et',
  GENERATE: 'Oluştur',
  PROCESS: 'İşle',
  EXECUTE: 'Çalıştır',
  RUN: 'Çalıştır',
  BUILD: 'Derle',
  DEPLOY: 'Dağıt',
  PUBLISH: 'Yayınla',
  UNPUBLISH: 'Yayından Kaldır',
  SCHEDULE_PUBLISH: 'Yayını Planla',
  DRAFT: 'Taslak Olarak Kaydet',
  REVIEW: 'İncele',
  APPROVE_REVIEW: 'İncelemeyi Onayla',
  REJECT_REVIEW: 'İncelemeyi Reddet',
  RESUBMIT: 'Yeniden Gönder',
  WITHDRAW: 'Geri Çek',
  FORWARD: 'İlet',
  REPLY: 'Yanıtla',
  REPLY_ALL: 'Tümünü Yanıtla',
  MARK_READ: 'Okundu Olarak İşaretle',
  MARK_UNREAD: 'Okunmadı Olarak İşaretle',
  STAR: 'Yıldızla',
  UNSTAR: 'Yıldızı Kaldır',
  FLAG: 'Bayrakla',
  UNFLAG: 'Bayrağı Kaldır',
  SPAM: 'Spam Olarak İşaretle',
  NOT_SPAM: 'Spam Değil',
  MOVE_TO_TRASH: 'Çöpe Taşı',
  RESTORE_FROM_TRASH: 'Çöpten Geri Yükle',
  EMPTY_TRASH: 'Çöpü Boşalt',
  PERMANENT_DELETE: 'Kalıcı Olarak Sil'
} as const

export const MENU_ITEMS = {
  DASHBOARD: 'Panel',
  STUDY: 'Çalışma',
  EXAMS: 'Sınavlar',
  ANALYTICS: 'Analitikler',


  POMODORO: 'Pomodoro',
  GOALS: 'Hedefler',
  CALENDAR: 'Takvim',
  PROFILE: 'Profil',
  SETTINGS: 'Ayarlar',
  LEADERBOARD: 'Liderlik Tablosu',
  SHOP: 'Mağaza',
  ACHIEVEMENTS: 'Başarımlar',
  STUDY_GROUPS: 'Çalışma Grupları',
  CHALLENGES: 'Meydan Okumalar',
  HELP: 'Yardım',
  ABOUT: 'Hakkında'
} as const

export const STATUS_TEXTS = {
  ONLINE: 'Çevrimiçi',
  OFFLINE: 'Çevrimdışı',
  AWAY: 'Uzakta',
  BUSY: 'Meşgul',
  INVISIBLE: 'Görünmez',
  ACTIVE: 'Aktif',
  INACTIVE: 'Pasif',
  PENDING: 'Beklemede',
  APPROVED: 'Onaylandı',
  REJECTED: 'Reddedildi',
  COMPLETED: 'Tamamlandı',
  IN_PROGRESS: 'Devam Ediyor',
  PAUSED: 'Duraklatıldı',
  CANCELLED: 'İptal Edildi',
  EXPIRED: 'Süresi Doldu',
  DRAFT: 'Taslak',
  PUBLISHED: 'Yayınlandı',
  ARCHIVED: 'Arşivlendi',
  DELETED: 'Silindi',
  LOCKED: 'Kilitli',
  UNLOCKED: 'Kilitsiz',
  PUBLIC: 'Herkese Açık',
  PRIVATE: 'Özel',
  SHARED: 'Paylaşıldı',
  UNSHARED: 'Paylaşılmadı',
  SYNCED: 'Senkronize',
  NOT_SYNCED: 'Senkronize Değil',
  CONNECTED: 'Bağlı',
  DISCONNECTED: 'Bağlantısız',
  LOADING: 'Yükleniyor',
  ERROR: 'Hata',
  SUCCESS: 'Başarılı',
  WARNING: 'Uyarı',
  INFO: 'Bilgi'
} as const

export const UNITS = {
  SECONDS: 'saniye',
  MINUTES: 'dakika',
  HOURS: 'saat',
  DAYS: 'gün',
  WEEKS: 'hafta',
  MONTHS: 'ay',
  YEARS: 'yıl',
  POINTS: 'puan',
  PERCENTAGE: 'yüzde',
  QUESTIONS: 'soru',
  TOPICS: 'konu',
  SUBJECTS: 'ders',
  SESSIONS: 'oturum',
  EXAMS: 'sınav',
  CARDS: 'kart',
  MAPS: 'harita',
  GOALS: 'hedef',
  BADGES: 'rozet',
  ACHIEVEMENTS: 'başarım',
  COINS: 'jeton',
  XP: 'deneyim puanı',
  LEVEL: 'seviye',
  STREAK: 'süreklilik',
  RANK: 'sıralama'
} as const

export const COLORS = {
  PRIMARY: '#6366f1',
  SECONDARY: '#8b5cf6',
  SUCCESS: '#10b981',
  WARNING: '#f59e0b',
  ERROR: '#ef4444',
  INFO: '#3b82f6',
  LIGHT: '#f8fafc',
  DARK: '#1e293b',
  GRAY: '#64748b',
  WHITE: '#ffffff',
  BLACK: '#000000',
  TRANSPARENT: 'transparent'
} as const

export const BREAKPOINTS = {
  XS: '0px',
  SM: '640px',
  MD: '768px',
  LG: '1024px',
  XL: '1280px',
  '2XL': '1536px'
} as const

export const Z_INDEX = {
  DROPDOWN: 1000,
  STICKY: 1020,
  FIXED: 1030,
  MODAL_BACKDROP: 1040,
  MODAL: 1050,
  POPOVER: 1060,
  TOOLTIP: 1070,
  TOAST: 1080
} as const

export const ANIMATION_DURATIONS = {
  FAST: 150,
  NORMAL: 300,
  SLOW: 500,
  VERY_SLOW: 1000
} as const

export const ANIMATION_EASINGS = {
  EASE: 'ease',
  EASE_IN: 'ease-in',
  EASE_OUT: 'ease-out',
  EASE_IN_OUT: 'ease-in-out',
  LINEAR: 'linear'
} as const



export const CACHE_DURATIONS = {
  SHORT: 5 * 60 * 1000, // 5 minutes
  MEDIUM: 30 * 60 * 1000, // 30 minutes
  LONG: 2 * 60 * 60 * 1000, // 2 hours
  VERY_LONG: 24 * 60 * 60 * 1000 // 24 hours
} as const

export const RATE_LIMITS = {
  LOGIN_ATTEMPTS: 5,
  API_REQUESTS_PER_MINUTE: 60,
  FILE_UPLOADS_PER_HOUR: 10,
  MESSAGE_SENDS_PER_MINUTE: 10,
  SEARCH_REQUESTS_PER_MINUTE: 30
} as const

export const DEFAULT_SETTINGS = {
  THEME: THEME_MODES.SYSTEM,
  LANGUAGE: LANGUAGES.TR,
  NOTIFICATIONS: true,
  SOUND_EFFECTS: true,
  AUTO_SAVE: true,
  SIDEBAR_COLLAPSED: false,
  SHOW_HINTS: true,
  SHOW_ANIMATIONS: true,
  HIGH_CONTRAST: false,
  LARGE_TEXT: false,
  REDUCE_MOTION: false,
  POMODORO_WORK_DURATION: 25,
  POMODORO_SHORT_BREAK: 5,
  POMODORO_LONG_BREAK: 15,
  POMODORO_SESSIONS_UNTIL_LONG_BREAK: 4,
  STUDY_REMINDER_INTERVAL: 60,
  EXAM_REMINDER_ADVANCE: 24,
  GOAL_REMINDER_FREQUENCY: 'daily',
  BACKUP_FREQUENCY: 'weekly',
  DATA_RETENTION_PERIOD: 365
} as const

export const FEATURE_FLAGS = {
  BETA_FEATURES: false,
  ADVANCED_ANALYTICS: true,
  SOCIAL_FEATURES: true,
  GAMIFICATION: true,
  AI_RECOMMENDATIONS: false,
  VOICE_NOTES: false,
  VIDEO_LESSONS: true,
  LIVE_SESSIONS: false,
  MOBILE_APP: true,
  OFFLINE_MODE: false,
  REAL_TIME_COLLABORATION: false,
  ADVANCED_REPORTING: true,
  CUSTOM_THEMES: true,
  THIRD_PARTY_INTEGRATIONS: false,
  PREMIUM_FEATURES: true
} as const

export const LIMITS = {
  FREE_PLAN: {
    STUDY_PLANS: 3,


    STORAGE_MB: 100,
    MONTHLY_EXAMS: 50,
    STUDY_GROUPS: 2,
    GOALS: 10,
    REMINDERS: 20
  },
  PREMIUM_PLAN: {
    STUDY_PLANS: 10,


    STORAGE_MB: 1000,
    MONTHLY_EXAMS: 200,
    STUDY_GROUPS: 10,
    GOALS: 50,
    REMINDERS: 100
  },
  PRO_PLAN: {
    STUDY_PLANS: -1, // Unlimited


    STORAGE_MB: 10000,
    MONTHLY_EXAMS: -1,
    STUDY_GROUPS: -1,
    GOALS: -1,
    REMINDERS: -1
  }
} as const

export const REGEX_PATTERNS = {
  EMAIL: VALIDATION_RULES.EMAIL,
  PASSWORD: VALIDATION_RULES.PASSWORD,
  PHONE: VALIDATION_RULES.PHONE,
  USERNAME: VALIDATION_RULES.USERNAME,
  NAME: VALIDATION_RULES.NAME,
  URL: /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/,
  HEX_COLOR: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
  SLUG: /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
  HASHTAG: /^#[a-zA-Z0-9_]+$/,
  MENTION: /^@[a-zA-Z0-9_]+$/,
  TIME: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
  DATE: /^\d{4}-\d{2}-\d{2}$/,
  DATETIME: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z?$/,
  CREDIT_CARD: /^\d{4}\s?\d{4}\s?\d{4}\s?\d{4}$/,
  CVV: /^\d{3,4}$/,
  POSTAL_CODE: /^\d{5}$/,
  IP_ADDRESS: /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
  MAC_ADDRESS: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/,
  UUID: /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
} as const

export const KEYBOARD_SHORTCUTS = {
  SAVE: 'Ctrl+S',
  COPY: 'Ctrl+C',
  PASTE: 'Ctrl+V',
  CUT: 'Ctrl+X',
  UNDO: 'Ctrl+Z',
  REDO: 'Ctrl+Y',
  SELECT_ALL: 'Ctrl+A',
  FIND: 'Ctrl+F',
  NEW: 'Ctrl+N',
  OPEN: 'Ctrl+O',
  PRINT: 'Ctrl+P',
  REFRESH: 'F5',
  FULLSCREEN: 'F11',
  HELP: 'F1',
  SEARCH: 'Ctrl+K',
  SETTINGS: 'Ctrl+,',
  LOGOUT: 'Ctrl+Shift+Q',
  TOGGLE_SIDEBAR: 'Ctrl+B',
  TOGGLE_THEME: 'Ctrl+Shift+T',
  QUICK_ADD: 'Ctrl+Shift+A',
  FOCUS_SEARCH: '/',
  ESCAPE: 'Escape',
  ENTER: 'Enter',
  SPACE: 'Space',
  TAB: 'Tab',
  SHIFT_TAB: 'Shift+Tab',
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  HOME: 'Home',
  END: 'End',
  PAGE_UP: 'PageUp',
  PAGE_DOWN: 'PageDown',
  DELETE: 'Delete',
  BACKSPACE: 'Backspace'
} as const

export const ACCESSIBILITY = {
  ARIA_LABELS: {
    CLOSE: 'Kapat',
    MENU: 'Menü',
    SEARCH: 'Ara',
    SETTINGS: 'Ayarlar',
    PROFILE: 'Profil',
    NOTIFICATIONS: 'Bildirimler',
    HELP: 'Yardım',
    PREVIOUS: 'Önceki',
    NEXT: 'Sonraki',
    PLAY: 'Oynat',
    PAUSE: 'Duraklat',
    MUTE: 'Sessiz',
    VOLUME: 'Ses',
    FULLSCREEN: 'Tam ekran',
    LOADING: 'Yükleniyor',
    ERROR: 'Hata',
    SUCCESS: 'Başarılı',
    WARNING: 'Uyarı',
    INFO: 'Bilgi'
  },
  ROLES: {
    BUTTON: 'button',
    LINK: 'link',
    MENU: 'menu',
    MENUITEM: 'menuitem',
    TAB: 'tab',
    TABPANEL: 'tabpanel',
    DIALOG: 'dialog',
    ALERT: 'alert',
    STATUS: 'status',
    PROGRESSBAR: 'progressbar',
    SLIDER: 'slider',
    CHECKBOX: 'checkbox',
    RADIO: 'radio',
    TEXTBOX: 'textbox',
    COMBOBOX: 'combobox',
    LISTBOX: 'listbox',
    OPTION: 'option',
    GRID: 'grid',
    GRIDCELL: 'gridcell',
    TREE: 'tree',
    TREEITEM: 'treeitem'
  }
} as const

export const SOCIAL_MEDIA = {
  FACEBOOK: 'https://facebook.com/lgstakip',
  TWITTER: 'https://twitter.com/lgstakip',
  INSTAGRAM: 'https://instagram.com/lgstakip',
  YOUTUBE: 'https://youtube.com/lgstakip',
  LINKEDIN: 'https://linkedin.com/company/lgstakip',
  DISCORD: 'https://discord.gg/lgstakip',
  TELEGRAM: 'https://t.me/lgstakip',
  WHATSAPP: 'https://wa.me/905551234567'
} as const

export const CONTACT_INFO = {
  EMAIL: 'info@lgstakip.com',
  PHONE: '+90 555 123 45 67',
  ADDRESS: 'İstanbul, Türkiye',
  SUPPORT_HOURS: 'Pazartesi - Cuma, 09:00 - 18:00',
  EMERGENCY_CONTACT: '+90 555 987 65 43'
} as const

export const LEGAL_LINKS = {
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_OF_SERVICE: '/terms-of-service',
  COOKIE_POLICY: '/cookie-policy',
  GDPR_COMPLIANCE: '/gdpr-compliance',
  REFUND_POLICY: '/refund-policy',
  ACCEPTABLE_USE: '/acceptable-use'
} as const

export const EXTERNAL_LINKS = {
  MEB: 'https://www.meb.gov.tr',
  OSYM: 'https://www.osym.gov.tr',
  LGS_GUIDE: 'https://www.meb.gov.tr/lgs',
  STUDY_TIPS: 'https://www.meb.gov.tr/study-tips',
  EXAM_CALENDAR: 'https://www.osym.gov.tr/calendar',
  UNIVERSITY_GUIDE: 'https://www.osym.gov.tr/universities'
} as const

export const ANALYTICS_EVENTS = {
  USER_REGISTERED: 'user_registered',
  USER_LOGGED_IN: 'user_logged_in',
  USER_LOGGED_OUT: 'user_logged_out',
  STUDY_SESSION_STARTED: 'study_session_started',
  STUDY_SESSION_COMPLETED: 'study_session_completed',
  EXAM_STARTED: 'exam_started',
  EXAM_COMPLETED: 'exam_completed',
  GOAL_CREATED: 'goal_created',
  GOAL_ACHIEVED: 'goal_achieved',
  BADGE_EARNED: 'badge_earned',
  LEVEL_UP: 'level_up',
  ITEM_PURCHASED: 'item_purchased',
  FRIEND_ADDED: 'friend_added',
  GROUP_JOINED: 'group_joined',
  CHALLENGE_COMPLETED: 'challenge_completed',
  MINDMAP_CREATED: 'mindmap_created',

  POMODORO_SESSION_COMPLETED: 'pomodoro_session_completed',
  SETTINGS_CHANGED: 'settings_changed',
  FEATURE_USED: 'feature_used',
  ERROR_OCCURRED: 'error_occurred',
  PAGE_VIEWED: 'page_viewed',
  BUTTON_CLICKED: 'button_clicked',
  FORM_SUBMITTED: 'form_submitted',
  SEARCH_PERFORMED: 'search_performed',
  FILE_UPLOADED: 'file_uploaded',
  DATA_EXPORTED: 'data_exported'
} as const

export const PERFORMANCE_METRICS = {
  LOAD_TIME_THRESHOLD: 3000, // 3 seconds
  RENDER_TIME_THRESHOLD: 1000, // 1 second
  API_RESPONSE_THRESHOLD: 2000, // 2 seconds
  MEMORY_USAGE_THRESHOLD: 100 * 1024 * 1024, // 100MB
  ERROR_RATE_THRESHOLD: 0.01, // 1%
  SATISFACTION_THRESHOLD: 4.0 // out of 5
} as const

export const SECURITY_CONFIG = {
  SESSION_TIMEOUT: 30 * 60 * 1000, // 30 minutes
  MAX_LOGIN_ATTEMPTS: 5,
  LOCKOUT_DURATION: 15 * 60 * 1000, // 15 minutes
  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_REQUIRE_UPPERCASE: true,
  PASSWORD_REQUIRE_LOWERCASE: true,
  PASSWORD_REQUIRE_NUMBERS: true,
  PASSWORD_REQUIRE_SYMBOLS: true,
  TWO_FACTOR_AUTH_ENABLED: false,
  ENCRYPTION_ALGORITHM: 'AES-256-GCM',
  HASH_ALGORITHM: 'SHA-256',
  JWT_EXPIRY: '1h',
  REFRESH_TOKEN_EXPIRY: '7d',
  CSRF_PROTECTION: true,
  XSS_PROTECTION: true,
  CONTENT_SECURITY_POLICY: true,
  SECURE_HEADERS: true
} as const

export const MONITORING_CONFIG = {
  ERROR_TRACKING: true,
  PERFORMANCE_MONITORING: true,
  USER_ANALYTICS: true,
  REAL_USER_MONITORING: true,
  SYNTHETIC_MONITORING: false,
  LOG_LEVEL: 'info',
  SAMPLE_RATE: 0.1, // 10%
  ALERT_THRESHOLDS: {
    ERROR_RATE: 0.05, // 5%
    RESPONSE_TIME: 5000, // 5 seconds
    MEMORY_USAGE: 0.8, // 80%
    CPU_USAGE: 0.8, // 80%
    DISK_USAGE: 0.9 // 90%
  }
} as const

// LGS Konu Hiyerarşisi
export const LGS_TOPICS_BY_SUBJECT = {
  'Türkçe': [
    'Sözcükte Anlam',
    'Cümlede Anlam',
    'Parçada Anlam',
    'Parçada Anlatım',
    'Parçada Yapı',
    'Sözel Mantık',
    'Tablo, Grafik ve Görsel Yorumlama',
    'Yazım Kuralları',
    'Noktalama İşaretleri',
    'Metin Türleri',
    'Söz Sanatları',
    'Fiilimsiler',
    'Cümlenin Öğeleri',
    'Fiilde Çatı',
    'Cümle Türleri',
    'Anlatım Bozuklukları',
    'Deyim ve Atasözleri'
  ],
  'Matematik': [
    'Çarpanlar ve Katlar',
    'Üslü İfadeler',
    'Kareköklü İfadeler',
    'Veri Analizi',
    'Olasılık',
    'Cebirsel İfadeler',
    'Doğrusal Denklemler',
    'Eşitsizlikler',
    'Üçgenler',
    'Eşlik ve Benzerlik',
    'Dönüşüm Geometrisi',
    'Geometrik Cisimler'
  ],
  'Fen Bilimleri': [
    'Mevsimler ve İklim',
    'DNA ve Genetik Kod',
    'Basınç',
    'Madde ve Endüstri',
    'Basit Makineler',
    'Enerji Dönüşümleri ve Çevre Bilimi',
    'Elektrik Yükleri ve Elektrik Enerjisi'
  ],
  'T.C. İnkılap Tarihi ve Atatürkçülük': [
    'Bir Kahraman Doğuyor',
    'Milli Uyanış: Bağımsızlık Yolunda Atılan Adımlar',
    'Ya İstiklal Ya Ölüm!',
    'Atatürkçülük ve Çağdaşlaşan Türkiye',
    'Demokratikleşme Çabaları',
    'Atatürk Dönemi Türk Dış Politikası',
    'Atatürk\'ün Vefatı ve Sonrası'
  ],
  'İngilizce': [
    'Friendship',
    'Teen Life',
    'In The Kitchen',
    'On The Phone',
    'The Internet',
    'Adventures',
    'Tourism',
    'Chores',
    'Science',
    'Natural Forces'
  ],
  'Din Kültürü ve Ahlak Bilgisi': [
    'Kader İnancı',
    'Zekât ve Sadaka',
    'Din ve Hayat',
    'Hz. Muhammed\'in Örnekliği',
    'Kur\'an-ı Kerim ve Özellikleri'
  ]
} as const

// Konu renkleri
export const TOPIC_COLORS = {
  'Türkçe': '#EF4444',
  'Matematik': '#3B82F6',
  'Fen Bilimleri': '#10B981',
  'T.C. İnkılap Tarihi ve Atatürkçülük': '#8B5CF6',
  'İngilizce': '#F59E0B',
  'Din Kültürü ve Ahlak Bilgisi': '#06B6D4'
} as const

// Konu ikonları
export const TOPIC_ICONS = {
  'Türkçe': '📘',
  'Matematik': '➗',
  'Fen Bilimleri': '🔬',
  'T.C. İnkılap Tarihi ve Atatürkçülük': '🏛️',
  'İngilizce': '🇬🇧',
  'Din Kültürü ve Ahlak Bilgisi': '🕌'
} as const